module.exports = __webpack_public_path__ + "img/board-line.c540045f.svg";